import type { GetStaticProps } from "next"
import { paramCase } from "change-case"

import { getPrivacyPolicy } from "~/api/prismic/singles"
import type {
  CookieSection,
  PrivacyPolicyProps,
  SimpleSection,
} from "~/screens/PrivacyPolicyPage"
import { PrivacyPolicyPage } from "~/screens/PrivacyPolicyPage"
import { enhanceStaticProps } from "~/utils/next/enhanceStaticProps"
import { getPreviewRef } from "~/utils/prismic/previewData"
import { asText } from "~/utils/prismic/richText"
import { withoutFalsyValues } from "~/utils/withoutFalsyValues"

export const getStaticProps: GetStaticProps<PrivacyPolicyProps> =
  enhanceStaticProps<PrivacyPolicyProps>(async ({ previewData }) => {
    const res = await getPrivacyPolicy({
      ref: getPreviewRef(previewData),
    })

    if (!res) {
      return { notFound: true }
    }

    const sections = res.data.body.map<SimpleSection | CookieSection | null>(
      (item) => {
        switch (item.slice_type) {
          case "section": {
            const sectionTitle = asText(item.primary.section_title)
            const titleId = paramCase(sectionTitle)

            return {
              type: "section",
              title: {
                id: titleId,
                text: sectionTitle,
              },
              body: item.primary.section_body,
            }
          }

          case "cookies_info":
            const cookiesInfo = item.primary

            if (!cookiesInfo.cookie) {
              return null
            }

            return {
              type: "cookies_info",
              name: cookiesInfo.cookie,
              title: cookiesInfo.cookie_title,
              description: cookiesInfo.description,
              showValueInTable: !!cookiesInfo.show_value_in_table,
            }

          default:
            return null
        }
      },
    )

    return {
      props: {
        title: asText(res.data.title),
        sections: withoutFalsyValues(sections),
      },
    }
  })

export default PrivacyPolicyPage
